import {
  PENDIENTE_ERROR,
  PENDIENTE_LOADING,
  PENDIENTE_SUCCESS,
} from "../../../constants/ActionTypes";
import axiosInstance from "../../../helpers/axiosInstance";

export const getPendientes = () => (dispatch) => {
  dispatch({
    type: PENDIENTE_LOADING,
  });

  axiosInstance()
    .get("/MovCajaMedicoDoc/pendiente/60")
    .then((res) => {
      dispatch({
        type: PENDIENTE_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: PENDIENTE_ERROR,
        payload: err,
      });
    });
};
